import { useQuery } from '@tanstack/react-query';

import type {
  ContentRecommendationType,
  RECOMMENDED_CONTENT_TYPES,
} from '@hivebrite/design-system/ContentRecommendation';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

interface UseGetContentRecommendationsProps {
  contentId: number;
  topicId?: number;
  type: RECOMMENDED_CONTENT_TYPES;
}

type ContentRecommendationResponseItem = {
  content_type: RECOMMENDED_CONTENT_TYPES;
  external_url: string;
} & Omit<ContentRecommendationType, 'externalUrl' | 'contentType'>;

export const useGetContentRecommendations = ({
  contentId,
  topicId,
  type,
}: UseGetContentRecommendationsProps): {
  data: Array<ContentRecommendationType>;
  isLoading: boolean;
} => {
  const { data, isLoading } = useQuery({
    queryKey: ['contentRecommendations', type, contentId],
    queryFn: async () => {
      const response = await axios.get<{
        data: ContentRecommendationResponseItem[];
      }>(
        Routes.private_frontoffice_recommendations_path({
          current_content_type: type,
          current_content_id: contentId,
          ...(topicId && { current_content_group_id: topicId }),
        }),
      );

      return response.data.data.map((item) => ({
        ...item,
        contentType: item.content_type,
        externalUrl: item.external_url,
      }));
    },
    enabled: !!type,
  });

  return {
    data: data || [],
    isLoading,
  };
};
